import { createAction, handleActions } from 'redux-actions';
import createRequestSaga, {
  createRequestActionTypes,
} from '../../lib/createRequestSaga';
import { takeLatest } from 'redux-saga/effects';

import * as salesCostsApi from '../../lib/api/salesCosts';
import { firstDayofYear, lastDayofYear } from '../../utils/calcDatetime';

const [LIST_SALES_COSTS, LIST_SALES_COSTS_SUCCESS, LIST_SALES_COSTS_FAILURE] =
  createRequestActionTypes('salesCosts/LIST_SALES_COSTS');
export const listSalesCosts = createAction(
  LIST_SALES_COSTS,
  (searchData) => searchData,
);
const listSalesCostsSaga = createRequestSaga(
  LIST_SALES_COSTS,
  salesCostsApi.getSalesCosts,
);

const UNLOAD_SALES_COSTS = 'salesCosts/UNLOAD_SALES_COSTS';
export const unloadSalesCosts = createAction(UNLOAD_SALES_COSTS);

const SET_BASE_FITERS = 'salesCosts/SET_BASE_FITERS';
export const setBaseFilters = createAction(
  SET_BASE_FITERS,
  (filters) => filters,
);

const RESET_BASE_FILTERS = 'salesCosts/RESET_BASE_FILTERS';
export const resetBaseFilters = createAction(RESET_BASE_FILTERS);

export function* salesCostsSaga() {
  yield takeLatest(LIST_SALES_COSTS, listSalesCostsSaga);
}

const initialState = {
  salesCosts: null,
  error: null,
  defaultFilters: {
    companyCd: 'ALL',
    searchKeyword: 'scLarge',
    searchWords: '',
    searchStrtDt: firstDayofYear,
    searchEndDt: lastDayofYear,
  },
};

const salesCosts = handleActions(
  {
    [LIST_SALES_COSTS_SUCCESS]: (state, { payload: data }) => ({
      ...state,
      salesCosts: data.list.map((cost) => ({
        id: cost.scUuid,
        scUuid: cost?.scUuid,
        scDt: cost?.scDt, //일자

        scLarge: cost?.scLarge, //계정과목(대)
        scSmall: cost?.scSmall, //계정과목(대)

        scWh: cost?.scWh, //사용처
        scItem: cost?.scItem, //품목
        scTotal: cost?.scTotal, //전체금액
        scPrice: cost?.scPrice, //금액
        scTax: cost?.scTax, //부가세
        isTax: cost?.isTax, //부가세 여부
        isBill: cost?.isBill, // 계산서 여부
        companyCd: cost?.companyCd, //회사
        companyNm: cost?.companyNm,

        usedUserUuid: cost.usedUserUuid,
        usedUserNm: cost.usedUserNm, //사용자
        usedDeptUuid: cost.usedDeptUuid,
        usedDeptNm: cost.usedDeptNm, //부서

        usedDisplayNm: cost.usedDisplayNm, // 대상 

        usedCategory: cost.usedCategory, //사용분류
        crtNm: cost.crtNm,
        crtDt: cost.crtDt,
        cngNm: cost.cngNm,
        cngDt: cost.cngDt,
      })),
      error: null,
    }),
    [LIST_SALES_COSTS_FAILURE]: (state, { payload: error }) => ({
      ...state,
      error: error,
    }),
    [UNLOAD_SALES_COSTS]: () => initialState,
    [RESET_BASE_FILTERS]: (state) => ({
      ...state,
      defaultFilters: initialState.defaultFilters,
    }),
    [SET_BASE_FITERS]: (state, { payload: filters }) => ({
      ...state,
      defaultFilters: filters,
    }),
  },
  initialState,
);

export default salesCosts;
